// extracted by mini-css-extract-plugin
export default {"head__container":"styles_head__container__WyE0w","head__text--host-name":"styles_head__text--host-name__ZSTpu","head__text--brand":"styles_head__text--brand__jtJo8"};